import {Variant} from "react-bootstrap/types";

export class CommunicatorState {
    constructor(public message: string = '',
                // Options: primary, secondary, success, danger, warning, info, dark, light
                public variant: Variant = 'primary',
                public visible: boolean = false,
                public keepVisibleForOnePageChange: boolean = false) {
    }
}